import API from '../shared/intersection.axios';
import config from '../config.json'
import {showError} from '../shared/notify.component';

const state = () => {
	return {
		steps: {},
		dictionary: []
	};
};

// getters
const getters = {
	getSteps(state) {
		return state.projects
	},
	getDictionary(state) {
		return state.dictionary
	}
};

// actions
const actions = {

	loadStepTree({}, id) {
		return API.get(config.endpoints.getStepTree + '?id=' + id)
			.then(response => {
				return response.data.result
			})
			.catch((error) => {
				showError(error.response.data.error, this._vm.$toast)
				// dispatch('setLoading', false)
			});
	},

	loadSteps({}, data) {
		return API.get(config.endpoints.getSteps + '?group_id=' + data.groupId + '&limit=1000&lang=' + data.lang)
		.then(response => {
			return response.data.result.data
		})
		.catch((error) => {
			showError(error.response.data.error, this._vm.$toast)
			// dispatch('setLoading', false)
		});
	},

	loadDictionary({commit}) {
		return API.get(config.endpoints.dictionaryGet + '?limit=1000')
		.then(response => {
			commit('setDictionary', response.data.result.data);
		})
		.catch((error) => {
			showError(error.response.data.error, this._vm.$toast)
			// dispatch('setLoading', false)
		});
	}
};

// mutations
const mutations = {

	setDictionary(state, data) {
		state.dictionary = data
	},

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
